<template>
    <div>
        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3 text-white">广州市锐指盈信息科技有限公司
                                    <span>创意、拼博、有理想</span>
                                </h1>
                                <p class="lead  text-white">提供软件开发服务。我们拥有丰富的技术实践经验和成功案例。我们团队富有创意，能够提供创新的解决方案，满足客户的个性化需求。我们以周到的服务态度，与客户紧密合作，确保项目的顺利交付和客户的满意度。</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section section-lg pt-lg-0 mt--250">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">经验丰富</h6>
                                    <p class="description mt-3">团队成员大部分来自广州某知名移动互联网公司，项目实战经验丰富。项目案例有：体育竞赛APP、涂鸦APP、商城系统、记账系统、客户管理系统等等。</p>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-planet" type="warning" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-warning text-uppercase">富有创意</h6>
                                    <p class="description mt-3">以富有创意为核心，不断追求独特而引人注目的解决方案，帮助客户在竞争激烈的市场中脱颖而出。我们通过创新思维和非传统方法，为客户提供独一无二的体验。</p>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-istanbul" type="info" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-info text-uppercase">服务周到</h6>
                                    <p class="description mt-3">始终以客户需求为导向，提供全方位的支持和关怀，确保客户在合作过程中得到最佳体验。积极响应客户的需求，以高效的沟通和及时的反馈，确保服务的满意度。</p>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="product-service" class="section">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="img/theme/sport-ui.png" class="img-fluid floating">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <icon name="ni ni-settings-gear-65" class="mb-5" size="lg" type="success" shadow
                                  rounded></icon>
                            <h3>体育竞赛APP</h3>
                            <p></p>
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-settings-gear-65"></badge>
                                        <h6 class="mb-0">体育赛事列表</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-html5"></badge>
                                        <h6 class="mb-0">球员详细数据</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="success" circle class="mr-3" icon="ni ni-satisfied"></badge>
                                        <h6 class="mb-0">赛事对阵图</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section bg-secondary">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-default shadow border-0">
                            <img v-lazy="'img/theme/graffiti-app.png'" class="card-img-top">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                     class="svg-bg">
                                    <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">涂鸦APP</h4>
                                <p class="lead text-italic text-white">传统的绘画需要纸张、颜料和画笔等物质资源，而使用涂鸦APP可以避免这些消耗，相比更环保，更经济。</p>
                            </blockquote>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <icon name="ni ni-settings" class="mb-5" size="lg" type="warning" shadow rounded></icon>

                            <h3>富有创意的涂鸦APP</h3>
                            <p class="lead">包含绘画工具、调色板、图片和贴纸、图层、动画制作、社区和分享以及教育辅助等等功能。</p>
                            <p class="lead">具有创意性和趣味性，激发用户的艺术创造力和学习兴趣。</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="about-us" class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-warning shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                        <div class="position-relative pl-md-5">
                            <img src="img/work.svg" class="img-center img-fluid">
                        </div>
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="d-flex px-3">
                            <div>
                                <icon name="ni ni-building" size="lg" class="bg-gradient-white" color="primary" shadow
                                      rounded></icon>
                            </div>
                            <div class="pl-4">
                                <h4 class="display-3 text-white">关于我们</h4>
                                <p class="text-white">广州市锐指盈信息科技有限公司成立于2016年，办公地点在广州市越秀区富力新天地中心1308，是一家提供软件开发服务以及软件开发咨询服务的公司。团队成员大部分来自广州某知名移动互联网公司，项目实战经验丰富、富有创意、服务周到。</p>
                            </div>
                        </div>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-satisfied" gradient="success" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-success">做过什么</h5>
                                    <p>主要为客户提供软件开发服务，项目案例有：体育竞赛APP、涂鸦APP、商城系统、记账系统、客户管理系统等等。通过这些项目，积累了大量的产品和技术经验，服务专业、周到。</p>
                                </div>
                            </div>
                        </card>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-active-40" gradient="warning" color="white" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-warning">未来计划</h5>
                                    <p>在现有的软件开发服务基础上，我们积极适应时代变化，拥抱AI时代。目前已经初步掌握了AI绘画的技术应用，未来继续深研AI相关技术，为客户进入AI时代提供更便捷周到的服务。</p>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>
        <section id="contact-us" class="section">
            <div class="container">
                <div class="row justify-content-center text-center">
                    <div class="col-lg-8">
                        <h2 class="display-3">联系我们</h2>
                        <p class="lead text-muted">
                            线上沟通加客服微信号：xbl_jc，添加请备注：软件外包<br/>
                            也可以前往我们的办公地点：广州市越秀区富力新天地中心1305
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <!-- <section class="section">
            <div class="container">
                <div class="row row-grid justify-content-center">
                    <div class="col-lg-8 text-center">
                        <h2 class="display-3">报价咨询服务包购买
                        </h2>
                        <p class="lead">购买服务后，我们将根据你的需求，深度沟通，并给出需求文档以及初步的报价方案。如果项目由我们开发，交付后将退回报价咨询服务包费用。购买后请通过上面的微信号联系我们。</p>
                        <div class="btn-wrapper">
                            <a href="/order" class="btn btn-primary mb-3 mb-sm-0">限时优惠18888，立即购买</a>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->

    </div>
</template>

<script>
export default {
  name: "home",
  components: {}
};
</script>

<style scoped>
.btn {
    background-color: #FF580C;
    border-color: #FF580C;
}
.btn:hover {
    background-color: #ED2400;
    border-color: #ED2400;
}
</style>
